/**
 * Safe localStorage wrappers. `typeof window === "undefined"` guards keep the
 * code SSR / Vitest-jsdom safe and also allow the bundle to load if the user
 * is in a private-window context that throws on access.
 */

export function readStorageItem(key: string): string | null {
  try {
    if (typeof window === "undefined") return null;
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeStorageItem(key: string, value: string): boolean {
  try {
    if (typeof window === "undefined") return false;
    window.localStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

export function removeStorageItem(key: string): boolean {
  try {
    if (typeof window === "undefined") return false;
    window.localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

export function readStorageJson<T>(key: string, fallback: T): T {
  const raw = readStorageItem(key);
  if (raw == null) return fallback;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

export function writeStorageJson(key: string, value: unknown): boolean {
  try {
    return writeStorageItem(key, JSON.stringify(value));
  } catch {
    return false;
  }
}
